import { FC, PropsWithChildren } from 'react';
import Typography from '@carrot-deprecated/typography';

export const FormFieldFeedback: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Typography variant="paragraphSmall" color="secondary">
      {children}
    </Typography>
  );
};
